import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { PrimaryAlert, InfoAlert, SuccessAlert, ErrorAlert } from "./Alerts";
export default () => markdown `
## Primary Alert
  ${(<ReactSpecimen>
      <PrimaryAlert text={"Es sind keine Suchresultate vorhanden"} icon={"Search"}/>
    </ReactSpecimen>)}

## Primary Alert with action
  ${(<ReactSpecimen>
      <PrimaryAlert text={"Daten konnten nicht geladen werden"} icon={"Cross"} action={{
    text: "Seite neu laden",
    onClick: () => {
        alert("Click");
    }
}}/>
    </ReactSpecimen>)}

## Vertically centered

In flex containers, alerts will be centered automatically.

  ${(<ReactSpecimen>
      <div style={{ height: 400, display: "flex" }}>
        <PrimaryAlert text={"Daten konnten nicht geladen werden"} icon={"Cross"} action={{
    text: "Seite neu laden",
    onClick: () => {
        alert("Click");
    }
}}/>
      </div>
    </ReactSpecimen>)}

## Info Alert
  ${(<ReactSpecimen>
      <InfoAlert text={"Das ist eine wichtige Information"}/>
    </ReactSpecimen>)}

## Success Alert
  ${(<ReactSpecimen>
      <SuccessAlert text={"Daten wurden erfolgreich geladen"}/>
    </ReactSpecimen>)}

## Error Alert
  ${(<ReactSpecimen>
      <ErrorAlert text={"Daten konnten nicht geladen werden"}/>
    </ReactSpecimen>)}

## Error Alert with action
  ${(<ReactSpecimen>
      <ErrorAlert text={"Daten konnten nicht geladen werden"} action={{
    text: "Seite neu laden",
    onClick: () => {
        alert("Click");
    }
}}/>
    </ReactSpecimen>)}
`;



// WEBPACK FOOTER //
// ./src/components/Alerts.docs.tsx